
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class TableWrapper extends Vue {
    @Prop(Boolean) readonly pagination!: boolean;
    @Prop({ default: 0 }) readonly page!: number;
    @Prop({ default: 0 }) readonly limit!: number;
    @Prop({ default: 0 }) readonly total!: number;
    @Prop({ default: () => [] }) readonly headers!: string[];
    @Prop({ default: () => [] }) readonly columns!: string[];
  }
